import { portfolioColumnActionType } from '../../constants';

const portfolioAllocationColumnReducer = (state = [], action) => {
    switch (action.type) {
        case portfolioColumnActionType.FETCH_ALLOCATION_COLUMN:
            return action.payload;
        default:
            return state;
    }
};
export default portfolioAllocationColumnReducer